<template>
  <div>
    <div class="status-text" :class='colorClass'>{{dlvStatusText}}</div>

    <div v-if="isNoDrive" class="driver-text-no">not assigned</div>
    <div v-if="!isNoDrive" class="driver-text">{{getStaff}}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ColumnDeliverStatus',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      getStaffName: 'getStaffName'
    }),
    getStaff () {
      return this.getStaffName(this.row.driverId)
    },
    isNoDrive () {
      return this.row.driverId === 0
    },
    isNoStatus () {
      return this.row.driverId === 0
    },
    colorClass () {
      let code = {
        0: 'color-status-0',
        1: 'color-status-1',
        2: 'color-status-2',
        3: 'color-status-3',
        99: 'color-status-99'
      }
      return code[this.row.deliveryStatus]
    }
  },
  created () {
    if (this.row.shipType) {
      this.dlvStatusText = this.dlvCode[this.row.shipType][this.row.deliveryStatus]
    } else {
      this.dlvStatusText = this.dlvCode[1][this.row.deliveryStatus]
    }
  },
  data () {
    return {
      dlvStatusText: '',
      dlvCode: {
        1: { 0: 'Preparing', 1: 'Ready', 2: 'Delivering', 3: 'Delivered', 99: 'Cancelled' },
        3: { 0: 'Preparing', 1: 'Ready', 2: 'Delivering', 3: 'Delivered', 99: 'Cancelled' },
        6: { 0: 'Preparing', 1: 'Ready', 2: 'Delivering', 3: 'Delivered', 99: 'Cancelled' },
        7: { 0: 'Preparing', 1: 'Ready', 2: 'Delivering', 3: 'Delivered', 99: 'Cancelled' },
        8: { 0: 'Preparing', 1: 'Ready', 2: 'Delivering', 3: 'Delivered', 99: 'Cancelled' },
        2: { 0: 'Preparing', 1: 'Ready', 2: 'Picking-up', 3: 'Picked up', 99: 'Cancelled' },
        4: { 0: 'Preparing', 1: 'Confirmed', 2: 'Picking-up', 3: 'Picked up', 99: 'Cancelled' },
        5: { 0: 'Preparing', 1: 'Confirmed', 2: 'Returning', 3: 'Returned', 99: 'Cancelled' }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.status-text {
  font-weight: bold;
  margin-top: 2px;
}
.driver-text-no {
  margin-bottom: 2px;
  font-size: 10px;
  font-style: italic;
  color: #c7c7c7;
}
.driver-text {
  margin-bottom: 2px;
  font-size: 11px;
  font-style: italic;
  color: #333333;
}
.color-status-0 {
  color: #f0b86f;
}
.color-status-1 {
  color: #dc7600;
}
.color-status-2 {
  color: #1890ff;
}
.color-status-3 {
  color: #4caf1b;
}
.color-status-99 {
  color: #a688c9;
}
</style>
